var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['party-button', _vm.selected ? 'selected' : '', _vm.italic ? 'italic' : '', _vm.big ? 'big' : '', _vm.arrowed ? 'arrowed' : '']},[_vm._v("\n  "+_vm._s(_vm.caption)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }